import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import BackButton from "../utils/backButton";
import { MoneyPicker } from "./partials/moneyPicker";
import { loadUsers } from "./partials/loadData";
import { Players } from "./partials/players";
import { Pay } from "./partials/pay";
import { GetGlobalColor } from "../utils/globalColors";
import Spinner from '../utils/spinner';


const SendMoney = () => {
    const [users, setUsers] = useState([]);
    const [recipient, setRecipient] = useState();
    const [sum, setSum] = useState(0);
    const navigate = useNavigate();
    const token = localStorage.getItem('userToken');
    const gameId = localStorage.getItem('gameId');
    const [error, setError] = useState(null);
    const [player, setPlayer] = useState("");
    const [balance, setBalance] = useState(0);
    const color = GetGlobalColor();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const loadData = async () => {
            await loadUsers(token, gameId, setUsers, setPlayer);

            try {
                const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/getPlayerData`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ token, gameId }),
                });

                const result = await response.json();
                if (result.balance) {
                    setBalance(result.balance);
                }
            } catch (error) {
                console.error("Error calling API:", error);
            }
            finally {
                setLoading(false);
            }
        };

        loadData();
    }, [token, gameId]);

    const handleSubmit = async () => {
        if (sum <= 0 || !sum) {
            setError("Prosimo vnesite veljavno vsoto!")
            return
        }

        if (recipient == null) {
            setError("Izberite prejemnika!")
            return
        }

        if (balance - sum < 0) {
            setError("Nimate dovolj sredstev na računu!")
            return
        }

        setError(null)
        try {
            const response = await fetch(`${process.env.REACT_APP_SERVER_URL}/pay`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({ recipient: recipient, sum: sum, gameId: gameId, user: player })
            });

            await response.json();
            console.log(JSON.stringify({ recipient: recipient, sum: sum, gameId: gameId, user: player }));

            navigate("/Game");


        } catch (error) {
            console.error("Error calling API:", error);
        }
    };

    return (
        <div className={`app-bg-${color} bg-overwrite`}>
            {loading &&
                <Spinner />
            }
            <BackButton to="/Game" />
            <div className="card ">
                <div className={`flex flex-col items-center text-center sub-card h-auto p-5 pt-10 card-bg-${color}`}>
                    <p className="wtext text-3xl mb-10">Plačilo igralcu</p>
                    {error && <p className="text-red-500 mb-4">{error}</p>}

                    <MoneyPicker setSum={setSum} sum={sum} />

                    <Players users={[{ player: "Mono Bank" }, ...users.filter(u => u.player !== player)]} recipient={recipient} setRecipient={setRecipient} />

                    <Pay handleSubmit={handleSubmit} />
                </div>

            </div>
        </div>
    )
};

export default SendMoney;
